import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Observable } from 'rxjs';

import { IDeposit } from '@interfaces/movements';
import { AuthService } from '@services/auth/auth.service';
import { FirebaseService } from '@services/firebase/firebase.service';
import { MovementsService } from '@services/movement/movement.service';
import { ReadsService } from '@services/reads/reads.service';

@Component({
  selector: 'app-notification-cloud',
  templateUrl: './notification-cloud.component.html',
  styleUrls: ['./notification-cloud.component.scss'],
})
export class NotificationCloudComponent implements OnInit {
  @Input() tab: string;
  count: number;
  unreadDeposits: IDeposit[];
  isIos: boolean;

  constructor(
    private platform: Platform,
    private authService: AuthService,
    private firebaseService: FirebaseService,
    private movementsService: MovementsService,
    private readsService: ReadsService,
    private router: Router,
  ) {
    this.isIos = this.platform.is('ios');
  }

  ngOnInit() {
    if (this.tab === 'movements') {
      this.movementsService.currentUnreadDepositsSubSource.subscribe((unreadDeposits) => {
        if (unreadDeposits) {
          this.unreadDeposits = unreadDeposits;
          this.count = unreadDeposits.length;
        }
      });
    } else if (this.tab === 'reads') {
      Observable.combineLatest([
        this.authService.currentUserSource,
        this.readsService.getLastReadDate(),
      ]).subscribe(async ([userInfo, lastReadDate]) => {
        if (userInfo && lastReadDate) {
          const dateTime = userInfo.lastReadDate || userInfo.createdAt;
          const lastUserReadDate = new Date(Math.max(dateTime.toDate(), 1603854000000));
          this.count = lastReadDate > lastUserReadDate ? await this.readsService.getUnreadCount(lastUserReadDate) : 0;
        }
      });
    }
  }

  onClick() {
    if (this.tab === 'movements' && this.unreadDeposits) {
      const batch = this.firebaseService.firestore.batch();
        this.unreadDeposits.forEach(deposit => {
          const collection = this.firebaseService.firestore.collection('deposits').doc(deposit.id);
          batch.update(collection, {read: true});
        });
      batch.commit();
      this.router.navigate(['movements']);
    } else if (this.tab === 'reads') {
      this.router.navigate(['reads']);
    } else {
      console.log('clicked bubble, tab: ', this.tab);
    }
  }

}
